<template>
  <!-- Slider main container -->
  <div class="swiper-container">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <slot />
    </div>

    <!-- navigation buttons -->
    <div class="swiper-button-prev" />
    <div class="swiper-button-next" />

    <!-- Add Pagination -->
    <div class="swiper-pagination" />

  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  mounted() {
    // eslint-disable-next-line no-unused-vars
    const macSwiper = new Swiper('.swiper-container', {
      speed: 400,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/SwiperGallery.vue